export enum InspectionDateDraggableEnum {
  AssignedToVehicle = 'assignedToVehicle',
  NotAssignedToVehicle = 'notAssignedToVehicle'
}
